import React from 'react'
import undefsafe from 'undefsafe'

import SearchHeader from './searchHeader'
import AlertsStreamContainer from '../../components/alerts/alertsStreamContainer'
import SearchPageArticle from './content/searchPageArticle'
import SearchPageRelatedPosts from './content/searchPageRelatedPosts'
import { logSearchResult } from '../../../common/utils/eventsApi'
import { getFlattenLocation } from '../../../common/utils/urlHelper'
import SimilarImagesPage from './similarImagesPage'
import SearchContentSection from './searchContentSection'
import PhotoduneSearchSurveyBanner from '../../components/banners/photoduneSearchSurveyBanner'
import { countSearchFor, searchesCount } from '../../../common/actions/search/trackSiteSearches'

class SearchPage extends React.Component {
  componentDidUpdate (prevProps) {
    const prevUser = prevProps.user
    const prevResultsUrl = prevProps.resultsUrl
    const { user, results, resultsUrl, location, currentSite, timeout } = this.props

    // Log to events api only when:
    // - user data will be loaded on search results page for the first time (inital search page render)
    // - successful search will be done after initial render
    // - timeout will happen (we need to log timeouts also)
    const newUserLoadAttempt = !prevUser.hasLoadAttempt && user.hasLoadAttempt
    const isNewSearch = prevResultsUrl !== resultsUrl
    const isTimeout = user.hasLoadAttempt && timeout
    if (newUserLoadAttempt || isNewSearch || isTimeout) {
      logSearchResult(results, location, currentSite, user, timeout)
      if (currentSite === 'photodune') countSearchFor(currentSite)
    }
  }

  render () {
    const {
      user,
      location,
      results,
      loading,
      seoMeta,
      ingestedContent,
      currentSite,
      baseUrl,
      relatedSearches,
      studioRecommendations
    } = this.props

    const didYouMeanByTerms = undefsafe(results, 'suggestions')
    const authorSuggestion = undefsafe(results, 'matching_author')
    const flattenLocation = getFlattenLocation(location)
    const resultsTerm = flattenLocation.query.term
    const shouldShowSimilarImagesPage = !!flattenLocation.query.item_id
    const showPhotoduneSurvey = currentSite === 'photodune' && searchesCount(currentSite) > 2

    return (
      <div className='canvas_body'>
        {loading ? <div className='loading-cover' /> : null}
        <SearchHeader
          location={flattenLocation}
          totalHits={results.total_hits}
          resultsTerm={resultsTerm}
          didYouMeanByTerms={didYouMeanByTerms}
          authorSuggestion={authorSuggestion}
          currentSite={currentSite}
          seoMeta={seoMeta}
          hideSearchBar={shouldShowSimilarImagesPage}
        />
        <div className='grid-container'>
          { showPhotoduneSurvey && <PhotoduneSearchSurveyBanner /> }
        </div>
        <AlertsStreamContainer />
        <div className='content-main--basic'>
          <div className='faceted-search'>
            { shouldShowSimilarImagesPage
              ? <SimilarImagesPage
                results={results}
                location={location}
                baseUrl={baseUrl}
                currentSite={currentSite}
              />
              : <SearchContentSection
                user={user}
                baseUrl={baseUrl}
                results={results}
                location={location}
                loading={loading}
                currentSite={currentSite}
                relatedSearches={relatedSearches}
                studioRecommendations={studioRecommendations}
              />
            }
          </div>

          {ingestedContent &&
            <div className='search-page-content'>
              {!!ingestedContent.article && <SearchPageArticle html={ingestedContent.article} />}
              {(ingestedContent.related_posts && ingestedContent.related_posts.length === 3) &&
                <SearchPageRelatedPosts posts={ingestedContent.related_posts} />
              }
            </div>
          }
        </div>
      </div>
    )
  }
}

export default SearchPage



// WEBPACK FOOTER //
// ./client/pages/search/searchPage.js